import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import SeoVehicleCard from './SeoVehicleCard';
import vehiclePropType from '../../propTypes/vehiclePropType';

/**
 * Static list of SeoVehicleCards rendered on the AI-bot SSR path
 * (US1994526 / TA4063706). The whole subtree is replaced on client hydration
 * by the interactive VehicleCards, so this only needs to be crawlable, not
 * interactive.
 *
 * useLabels() is a render-phase hook (reads from the ws-scripts-provided
 * context), so it resolves synchronously during renderToString — the region
 * label lands in the SSR HTML with no browser fetch, mirroring Widget.jsx.
 */
const SeoVehicleCards = ({ inventory }) => {
	const labels = useLabels();

	return (
		<ul
			className="seo-vehicle-cards vehicle-card-grid list-unstyled"
			aria-label={labels.get('MATCHING_VEHICLES')}
		>
			{inventory.map((vehicle) => (
				<SeoVehicleCard key={vehicle.uuid} vehicle={vehicle} />
			))}
		</ul>
	);
};

SeoVehicleCards.propTypes = {
	inventory: PropTypes.arrayOf(vehiclePropType)
};

SeoVehicleCards.defaultProps = {
	inventory: []
};

export default SeoVehicleCards;
